import type { ContactFieldDef, FieldType } from "./contacts-api";
import { t } from "@/lib/i18n";

// Подписи и иконки типов и видимости полей контакта (id — как на сервере).
export const fieldTypes: { id: FieldType; label: string; icon: string }[] = [
  { id: "text", label: t("Текст"), icon: "ri-text" },
  { id: "number", label: t("Число"), icon: "ri-hashtag" },
  { id: "email", label: "Email", icon: "ri-mail-line" },
  { id: "phone", label: t("Телефон"), icon: "ri-phone-line" },
  { id: "telegram", label: t("Telegram (телефон или @ник)"), icon: "ri-telegram-line" },
  { id: "date", label: t("Дата"), icon: "ri-calendar-line" },
  { id: "multi", label: t("Список значений"), icon: "ri-list-check-2" },
  { id: "image", label: t("Изображение"), icon: "ri-image-line" },
  { id: "bool", label: t("Да / Нет"), icon: "ri-toggle-line" },
];

export const fieldVisibility: { id: ContactFieldDef["visibility"]; label: string; icon: string }[] = [
  { id: "always", label: t("Всегда показывать"), icon: "ri-eye-line" },
  { id: "hidden", label: t("Скрыто"), icon: "ri-eye-off-line" },
  { id: "admin", label: t("Только админ"), icon: "ri-lock-line" },
];

export const typeOf = (id: string) => fieldTypes.find((ft) => ft.id === id) ?? fieldTypes[0];
export const visOf = (id: string) => fieldVisibility.find((v) => v.id === id) ?? fieldVisibility[0];
